<ng-container>
    <div class="container-fluid audit-content px-0 pe-0">
        <hr class="m-0">
        <div class="py-2 px-3">
            <p class="audit-title">Audit Event Logs</p>
            <lib-audit-log-filter [enterpriseMap]="enterpriseMap"
                                  [enterpriseLabels]="enterpriseLabels" (auditLogFilterChange)="handleFilterChange($event)"></lib-audit-log-filter>
            <lib-audit-log-table [enterpriseMap]="enterpriseMap"
                                 [enterpriseLabels]="enterpriseLabels" [auditLogFilterObs]="auditLogFilterSubject"></lib-audit-log-table>
        </div>
    </div>
</ng-container>
